import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';

export const getIsDemographicsAudiencesEnabled = accountConfig => {
    return accountConfig?.[FEATURE_FLAGS.DEMOGRAPHICS_AUDIENCES_REPORT_ENABLED] === 'true';
};
